import { Col, Pagination, Row, Spin } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from '~/common/hooks/useTranslation'
import BodyProfile from '~/components/shared-components/BodyProfile'
import { useHash } from '~/views/redux/hooks/useHash'
import configs from '~/configs'
import { NodataMonster } from '~/components/shared-components/NoData/NodataMonster'
import SellModal from '~/components/Modals/SellModal'
import TransactionCompletedSell from '~/components/Modals/TransactionCompletedSell'
import { useSDK } from '@metamask/sdk-react'
import { ethersWeb3Provider, providerOAS } from '~/blockchain/oas'
import {
  checkTransactionConfirmation,
  getBalanceOAS,
  hexToNumberString,
  toWei,
} from '~/blockchain/provider'
import { changeNetworkInMetamask } from '~/blockchain/metamask'
import {
  getContractHash,
  ifaceContractMarketplace,
} from '~/blockchain/contract'
import { BoxCardHash } from '~/components/shared-components/Card/BoxCardHash'
import { useTheme } from '~/common/theme/redux/hooks/useTheme'
import { scrollToTop } from '~/helpers/common'
import { sendOASTransaction } from '~/helpers/oasTransaction'

export const HashChipNFT = () => {
  const { sdk } = useSDK()
  const [pageSize, setPageSize] = useState(
    JSON.parse(localStorage.getItem('hashNFTMyAssets'))?.pageSize || 10,
  )
  // const [page, setPage] = useState(
  //   JSON.parse(localStorage.getItem('hashNFTMyAssets'))?.page || 1,
  // )
  const [page, setPage] = useState(1)
  const [isModalSell, setIsModalSell] = useState(false)
  const [nftActive, setNftActive] = useState()
  const [isLoadingModal, setLoadingModal] = useState(false)
  const [balanceOAS, setBalanceOAS] = useState(0)
  const [txHash, setTxHash] = useState()
  const [isModalSuccessSell, setIsModalSuccessOpenSell] = useState(false)

  const {
    actions,
    data: { allHashUser, totalCountUser, isLoading },
  } = useHash()
  const {
    data: { user },
  } = useTheme()

  const { t } = useTranslation()

  const refreshData = useCallback(() => {
    const params = {
      page,
      pageSize: pageSize,
      wallet_address: user.address_wallet,
      category: ["Hash_Chip_NFT"],
    }
    actions.getAllHashUser(params, () => {
      scrollToTop()
    })
  }, [page, pageSize, actions, user.address_wallet])

  useEffect(() => {
    if (user) {
      refreshData()
      loadBalanceOAS()
    }
  }, [page, pageSize, txHash])

  const loadBalanceOAS = () => {
    getBalanceOAS(user.address_wallet).then((res) => {
      setBalanceOAS(res)
    })
  }

  const handleSell = async (tokenID, price, quantity = 1) => {
    try {
      setLoadingModal(true)
      if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const {
          contract,
          iface,
          address: addressContract,
        } = getContractHash(nftActive?.contractAddress)

        let checkAllow
        let allowanceHash = await contract.getApproved(tokenID)
        checkAllow =
          allowanceHash.toLowerCase() ===
          configs.ADDRESS_MARKETPLACE.toLowerCase()

        if (checkAllow) {
          sell(tokenID, price, quantity, addressContract)
        } else {
          const transactionData = {
            from: providerOAS.accounts[0],
            data: iface.encodeFunctionData('approve', [
              configs.ADDRESS_MARKETPLACE,
              tokenID,
            ]),
            to: addressContract,
            // nonce: nonce,
            // gasLimit: 21000,
          }
          const transaction = await sendOASTransaction(transactionData)
          // const signedTransaction = await providerOAS.request({
          //   method: 'eth_signTransaction',
          //   params: [data],
          // })

          // const transaction = await ethersWeb3Provider.sendTransaction(
          //   String(signedTransaction),
          // )
          checkTransactionConfirmation(transaction?.hash).then((r) => {
            if (r === 'confirmed') {
              console.log('Approve:', r, transaction?.hash)
              sell(tokenID, price, quantity, addressContract)
            }
          })
        }
      } else {
        await sdk.connect()
        await changeNetworkInMetamask(
          sdk.getProvider(),
          configs.NETWORK.chainId,
          setLoadingModal,
        )
        await sdk.connect()
        let networkId = await sdk
          .getProvider()
          .request({ method: 'eth_chainId', params: [] })
        networkId = hexToNumberString(networkId)

        if (parseInt(networkId) !== parseInt(configs.NETWORK.chainId)) return

        const {
          contract,
          iface,
          address: addressContract,
        } = getContractHash(nftActive?.contractAddress)

        let checkAllow
        let allowanceHash = await contract.getApproved(tokenID)
        checkAllow =
          allowanceHash.toLowerCase() ===
          configs.ADDRESS_MARKETPLACE.toLowerCase()

        if (checkAllow) {
          sell(addressContract, tokenID, price, quantity)
        } else {
          let nonce = await sdk.getProvider().request({
            method: 'eth_getTransactionCount',
            params: [user.address_wallet, 'latest'],
          })
          sdk
            .getProvider()
            .request({
              method: 'eth_sendTransaction',
              params: [
                {
                  from: user.address_wallet,
                  data: iface.encodeFunctionData('approve', [
                    configs.ADDRESS_MARKETPLACE,
                    tokenID,
                  ]),
                  to: addressContract,
                  nonce,
                },
              ],
            })
            .then((txHash) => {
              checkTransactionConfirmation(txHash).then((r) => {
                if (r === 'confirmed') {
                  console.log('Approve:', r, txHash)
                  new Promise((resolve) => setTimeout(resolve, 3000))
                    .then(() => {
                      sell(addressContract, tokenID, price, quantity)
                    });
                }
              })
            })
            .catch((error) => {
              setLoadingModal(false)
              console.error(error)
            })
        }
      }
    } catch (error) {
      console.error(error)
      setLoadingModal(false)
    }
  }

  const sell = async (addressContract, tokenID, price, quantity) => {
    try {
      if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const transactionData = {
          from: providerOAS.accounts[0],
          data: ifaceContractMarketplace.encodeFunctionData(
            'createMarketItemSale',
            [addressContract, tokenID, toWei(price), quantity],
          ),
          to: configs.ADDRESS_MARKETPLACE,
          // nonce: nonce,
          // gasLimit: 21000,
        }
        const transaction = await sendOASTransaction(transactionData)
        // const signedTransaction = await providerOAS.request({
        //   method: 'eth_signTransaction',
        //   params: [data],
        // })

        // const transaction = await ethersWeb3Provider.sendTransaction(
        //   String(signedTransaction),
        // )
        checkTransactionConfirmation(transaction?.hash).then((r) => {
          if (r === 'confirmed') {
            setTxHash(transaction?.hash)
            setLoadingModal(false)
            handleCancelModalSell()
            showModalSuccessSell()
          }
        })
      } else {
        let nonce = await sdk.getProvider().request({
          method: 'eth_getTransactionCount',
          params: [user.address_wallet, 'latest'],
        })
        sdk
          .getProvider()
          .request({
            method: 'eth_sendTransaction',
            params: [
              {
                from: user.address_wallet,
                data: ifaceContractMarketplace.encodeFunctionData(
                  'createMarketItemSale',
                  [addressContract, tokenID, toWei(price), quantity],
                ),
                to: configs.ADDRESS_MARKETPLACE,
                nonce,
              },
            ],
          })
          .then((txHash) => {
            checkTransactionConfirmation(txHash).then((r) => {
              if (r === 'confirmed') {
                setTxHash(txHash)
                setLoadingModal(false)
                handleCancelModalSell()
                showModalSuccessSell()
              }
            })
          })
          .catch((error) => {
            setLoadingModal(false)
            console.error(error)
          })
      }
    } catch (error) {
      setLoadingModal(false)
    }
  }

  const handleCancelModalSell = () => {
    setIsModalSell(false)
    setLoadingModal(false)
  }

  const showModalSuccessSell = () => {
    setIsModalSuccessOpenSell(true)
  }

  const handleCancelSuccessSell = () => {
    setIsModalSuccessOpenSell(false)
  }

  const showModalSell = () => {
    setIsModalSell(true)
  }

  const onChangePage = (page) => {
    setPage(page)
  }

  const onChangePageSize = (current, size) => {
    setPageSize(size)
  }

  return (
    <BodyProfile>
      <Row>
        <Col span={24} >
          <Spin spinning={isLoading}>
            <div className="flex flex-wrap justify-center gap-4">
              {allHashUser
                .map((data, i) => (
                  <BoxCardHash
                    t={t}
                    key={i?.toString()}
                    data={data}
                    img={`../imgs/common/result.png`}
                    button={{
                      title: t('sell'),
                      functionButton: () => {
                        setNftActive(data)
                        showModalSell()
                      },
                    }}
                  />
                ))}
            </div>
          </Spin>
          {!isLoading && totalCountUser === 0 && <NodataMonster />}
          {totalCountUser > 0 && (
            <div className="pagination__common">
              <Pagination
                onChange={onChangePage}
                onShowSizeChange={onChangePageSize}
                className="mt-5"
                size="small"
                locale={{ jump_to: 'Go to', page: '' }}
                total={totalCountUser}
                current={page}
                pageSize={pageSize}
                showSizeChanger
                showQuickJumper
                showTitle
              />
            </div>
          )}
          <SellModal
            action={{
              isModalOpen: isModalSell,
              handleOk: handleSell,
              handleCancel: handleCancelModalSell,
            }}
            t={t}
            tokenID={nftActive?.tokenId ?? nftActive?.nft_id}
            loadingModal={isLoadingModal}
            name={`${nftActive?.name} (#${nftActive?.tokenId})`}
            balance={balanceOAS}
          />
          <TransactionCompletedSell
            action={{
              isModalOpen: isModalSuccessSell,
              handleOk: handleCancelSuccessSell,
              handleCancel: handleCancelSuccessSell,
            }}
            t={t}
            name={`${nftActive?.name} (#${nftActive?.tokenId})`}
            store={'Marketplace'}
            txHash={txHash}
          />
        </Col>
      </Row>
    </BodyProfile>
  )
}

export default HashChipNFT